
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/smart-chains/tutorials/create-a-default-smart-chain",
      function () {
        return require("private-next-pages/en/docs/smart-chains/tutorials/create-a-default-smart-chain/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/smart-chains/tutorials/create-a-default-smart-chain"])
      });
    }
  